module.exports = __webpack_public_path__ + "static/sec6-bg-910a05841c7837db8c6c2b561d6fe02d.jpg";